import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { AppMenuService, AuthService, DynamicFieldModel, DynamicFormComponent, MenuItem, Role } from '@share';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormatEmitEvent, NzTreeComponent, NzTreeModule, NzTreeNode } from 'ng-zorro-antd/tree';
import { ChangeDetectorRef } from '@angular/core';
import { RoleService } from './role.service';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { HttpParams } from '@angular/common/http';


interface Permission {
  name: string; // Example property
  hasAccess: boolean; // Example property
}

export function requiredArrayValidator(minLength: number = 1): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    return Array.isArray(value) && value.length >= minLength ? null : { requiredArray: true };
  };
}

@Component({
  selector: 'app-role',
  imports: [NzTagModule, NzToolTipModule, NzIconModule, NzDividerModule, NzPopconfirmModule, NzCardModule, NzTableModule, CommonModule, NzGridModule, FormsModule, NzButtonModule, NzButtonModule, FormsModule, NzInputModule, NzTreeModule, CommonModule, ReactiveFormsModule],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss'
})
export class RoleComponent implements OnInit {

  readonly authService = inject(AuthService);
  loading: boolean = false;
  listOfData: Array<Role> = [];

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Role Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Role Name required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    {
      label: 'Permissions',
      name: 'permissions',
      type: 'tree',
      treedata: [],
      value: [],
      placeholder: '',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Permissions required',
        }
      ],
    }
  ];

  searchValue = '';
  pageIndex = '';
  pageSize = '';

  _pageSize = 10;
  _pageIndex = 1;
  total = 0;
  divHeight: string;
  tableHeight: string;
  width: string;
  tablewidth: string;

  constructor(private readonly modalService: NzModalService, private readonly appMenuService: AppMenuService, private readonly roleService: RoleService, private readonly fb: FormBuilder, private readonly cdr: ChangeDetectorRef) {

  }

  @HostListener('window:resize')
  calculateHeight() {
    // Subtract heights of header, footer, padding, etc.
    const offset = 300;
    const tableHeightoffset = 350;
    this.divHeight = `${window.innerHeight - offset}px`;// adjust based on your layout
    this.tableHeight = `${window.innerHeight - tableHeightoffset}px`;
    const offsetWidth = 400;
    this.width = `${window.innerWidth - offsetWidth}px`;
    this.tablewidth = this.width;

  }

  ngOnInit(): void {
    this.calculateHeight();
    this.loadData();
    this.appMenuService.getMenu().subscribe(x => {
      let leafMenu = this.getLeafMenus(x);
      this.fieldConfig[2].treedata = leafMenu;
    });
  }

  loadData() {
    let params = new HttpParams()
      .set('searchValue', this.searchValue)
      .set('page', this._pageIndex.toString())
      .set('pageSize', this._pageSize.toString());
    this.roleService.getRoles(params).subscribe(x => {
      console.log(x);
      this.listOfData = x.roles; this.total = x.totalCount
    });
  }

  onPageIndexChange(pageIndex: number): void {
    this._pageIndex = pageIndex;
    this.loadData();
  }



  ngAfterViewInit(): void {
  }

  getLeafMenus(menus: any[]): any[] {
    let result: any[] = [];

    for (const menu of menus) {
      if (menu.children && menu.children.length > 0) {
        result = result.concat(this.getLeafMenus(menu.children));
      }
      if (menu.hasPermission === true) {

        menu.children = [];
        menu.children.push({ key: `${menu.key}.view`, title: `View ${menu.key}`, isLeaf: true } as MenuItem);
        menu.children.push({ key: `${menu.key}.add`, title: `Add ${menu.key}`, isLeaf: true } as MenuItem);
        menu.children.push({ key: `${menu.key}.edit`, title: `Edit ${menu.key}`, isLeaf: true } as MenuItem);
        menu.children.push({ key: `${menu.key}.delete`, title: `Delete ${menu.key}`, isLeaf: true } as MenuItem);

        result.push(menu);
      }
    }

    return result;
  }

  addRole() {
    const modalRef: NzModalRef = this.modalService.create({
      nzTitle: 'Create Role',
      nzContent: DynamicFormComponent,  // Use dynamic form component
      nzData: { fields: this.fieldConfig, data: null },
      nzFooter: null,
      nzMaskClosable: false   // We'll add footer buttons manually
    });
    modalRef.updateConfig({
      nzFooter: [{
        label: 'Submit',
        type: 'primary',
        onClick: () => this.handleSubmit(modalRef)
      },
      {
        label: 'Cancel',
        onClick: () => this.handleCancel(modalRef)
      }

      ]
    });
  }
  edit(data: Role) {
    const modalRef: NzModalRef = this.modalService.create({
      nzTitle: 'Edit Role',
      nzContent: DynamicFormComponent,  // Use dynamic form component
      nzData: { fields: this.fieldConfig, data: data },
      nzFooter: null,
      nzMaskClosable: false   // We'll add footer buttons manually
    });
    modalRef.updateConfig({
      nzFooter: [{
        label: 'Submit',
        type: 'primary',
        onClick: () => this.handleUpdate(modalRef)
      },
      {
        label: 'Cancel',
        onClick: () => this.handleCancel(modalRef)
      }

      ]
    });
  }

  handleCancel(modalRef: NzModalRef): void {
    console.log('Modal closed without submission');
    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.expandedKeys = [];
    modalRef.destroy();  // Close the modal
  }

  // Handle Submit button action
  handleSubmit(modalRef: NzModalRef, index: number = -1): void {
    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {
      let data = component.form.value;
      this.roleService.createRole(data).subscribe(x => this.roleService.getRoles().subscribe(y => this.listOfData = y));
      this.listOfData.push(data);
      component.expandedKeys = [];
      modalRef.destroy();
    } else {
      component.form.markAllAsTouched();
    }
  }

  handleUpdate(modalRef: NzModalRef, index: number = -1): void {

    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {
      let data = component.form.value;
      this.roleService.updateRole(data).subscribe(x => this.roleService.getRoles().subscribe(y => {this.listOfData = y.roles;this.total=y.totalCount;}));
      component.expandedKeys = [];
      modalRef.destroy();
    } else {
      component.form.markAllAsTouched();
    }
  }

  getTagColor(permission: string): string {
    if (permission.includes('view')) return 'green';
    if (permission.includes('add')) return 'blue';
    if (permission.includes('edit')) return 'orange';
    if (permission.includes('delete')) return 'red';
    if (!permission.includes('.')) return 'purple';
    return 'default'; // Default color for unknown permissions
  }

  cancel(): void {

  }

  confirm(data: any) {
    console.log(JSON.stringify(data));
    this.roleService.deleteRole({ deleted_id: data.id }).subscribe(x => this.roleService.getRoles().subscribe(y => this.listOfData = y));
  }

  onFilterChange() {
    this._pageIndex = 1;
    this.loadData();
  }
}
